import * as React from 'react'
import { useLayoutEffect, useState } from 'react'
import store from '../../../../stores/photoswipe_store'

const I18n = window.I18n as typeof window.I18n & { t: (key: string) => string }

export default function DownloadButton () {
  const [downloadUrl, setDownloadUrl] = useState<string | undefined>(() => store.currentItem?.downloadUrl)

  useLayoutEffect(() => {
    const updateDownloadUrl = () => setDownloadUrl(store.currentItem?.downloadUrl)
    const listener = store.addListener('PswpChanged', updateDownloadUrl)
    updateDownloadUrl()
    return () => listener.remove()
  }, [])

  if (!downloadUrl) return null
  return (
    <div className="pswp__download-button">
      <a className="fa fa-download" title={I18n.t('application.actions.download')} aria-hidden="true" href={downloadUrl} />
    </div>
  )
}
